import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { DATE_FORMAT } from 'consts';

interface IStore {
  start: string;
}

const initialDate = dayjs().subtract(1, 'day').format(DATE_FORMAT);

const initialState: IStore = {
  start: initialDate,
};

export const start: CaseReducer<IStore, PayloadAction<string>> = (state, action) => {
  if (action.payload === 'prev') {
    state.start = dayjs(state.start, DATE_FORMAT).subtract(1, 'day').format(DATE_FORMAT);
  }
  if (action.payload === 'next') {
    state.start = dayjs(state.start, DATE_FORMAT).subtract(-1, 'day').format(DATE_FORMAT);
  }
  if (action.payload === 'reset') {
    state.start = initialDate;
  }
};

export const paginationStartSlice = createSlice({
  name: 'paginationStart',
  initialState,
  reducers: {
    start,
  },
});

const { start: setPaginationStart } = paginationStartSlice.actions;

export { setPaginationStart };
